import moment from 'moment'

export const convertTimezone = {
    utcToLocal: function (date) {
        var stillUtc = moment.utc(date).toDate();
        return  moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
    },
    localToUtc: function (date) {
        return moment(date).utc().format('YYYY-MM-DD HH:mm:ss');
    }
};



// WEBPACK FOOTER //
// ./src/plugins/convertTimezone.js